module.exports = __webpack_public_path__ + "img/corona.7c983619.svg";